import { apiClient } from "../apiClient";
export const GIOI_TINH_ENDPOINT = "gioi-tinh";
export const gioiTinhApi = {
  SelectAll: () => apiClient.get(`${GIOI_TINH_ENDPOINT}`),
};
